/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Divider, Button } from '@material-ui/core';
import { WS_ACTION_TYPES, POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import { commands } from '../../constants/index';
import { GoNow, RoutesButton } from '../index';
import styles from './styles';

const {
  addStopCommand,
  waypointEditTripCommand,
  waypointEditstopsCommand,
  saveCommand,
  waypointShareEtaCommand,
  shareCommand,
  callCommand,
  continueTripCommand,
  replaceStopCommand,
} = commands;
const waypointScreen = () => ['/waypoint-details'].includes(window.location.pathname);
const destinationInformation = () => ['/destinationInformation'].includes(window.location.pathname);
const favoritesScreen = () => ['/favorites'].includes(window.location.pathname);
const recentsScreen = () => ['/recents'].includes(window.location.pathname);
const mpScreen = () => ['/mp-information'].includes(window.location.pathname);
const routesScreen = () => ['/routes'].includes(window.location.pathname);
const filterScreen = () => ['/filter'].includes(window.location.pathname);
const sortByScreen = () => ['/sort-by'].includes(window.location.pathname);

const Buttons = ({
  t,
  classes,
  sendMessageToSocket,
  reset,
  addStopInProgress,
  addStopInProgressStatus,
  stops,
  incoming_stop,
  saveStop,
  markPoiList,
  markSinglePoi,
  editListInprogress,
  editList,
  routeInProgress,
  dialogContinue,
  // applyFilter,
}) => {
  const onClickAddStop = () => {
    markSinglePoi(true);
    markPoiList(false);
    addStopInProgress(true);
    sendMessageToSocket(addStopCommand);
  };

  const onClickSaveStop = () => {
    sendMessageToSocket(addStopCommand);
    markSinglePoi(false);
    markPoiList(false);
    saveStop(incoming_stop);
  };

  const onClickReplaceStop = () => {
    sendMessageToSocket(replaceStopCommand);
    dialogContinue(() => {
      markSinglePoi(false);
      markPoiList(false);
      saveStop(incoming_stop);
    });
  };

  const onClickEditStop = () => {
    sendMessageToSocket(waypointEditstopsCommand);
    navigate('/edit-stop');
  };

  const onClickEndTrip = () => {
    sendMessageToSocket(waypointEditTripCommand);
    reset();
    navigate('/');
  };

  const onClickSaveFavRecent = () => {
    sendMessageToSocket(saveCommand);
    dialogContinue(() => {
      editList(false);
    });
  };

  const onClickShareETA = () => {
    sendMessageToSocket(waypointShareEtaCommand);
  };

  const onClickShare = () => {
    sendMessageToSocket(shareCommand);
  };

  const onClickInitiateCall = () => {
    sendMessageToSocket(callCommand);
  };

  const onClickContinueTrip = () => {
    sendMessageToSocket(continueTripCommand);
  };

  // const onClickApplyFilter = () => {
  //   applyFilter();
  //   navigate('/poiList');
  // };

  return (
    <React.Fragment>
      {waypointScreen() ? (
        <span>
          <span className={classes.container}>
            {Object.keys(stops).length === 0 ? (
              <React.Fragment>
                <Button onClick={onClickAddStop} className={classes.button__wrapper}>
                  <Typography className={classes.button__text}>
                    {t('poi-details.label.action-button.add-stops')}
                  </Typography>
                </Button>
                <Divider className={classes.divider} />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Button onClick={onClickEditStop} className={classes.button__wrapper}>
                  <Typography className={classes.button__text}>
                    {t('poi-details.label.action-button.edit-stop')}
                  </Typography>
                </Button>
                <Divider className={classes.divider} />
              </React.Fragment>
            )}
            <Button onClick={onClickShareETA} className={classes.button__wrapper}>
              <Typography className={classes.button__text}>
                {t('poi-details.label.action-button.share-eta')}
              </Typography>
            </Button>
          </span>
          <span className={classes.container}>
            <RoutesButton />
            <Button onClick={onClickEndTrip} className={classes.endTrip}>
              <Typography className={classes.button__text__white}>
                {t('poi-details.label.action-button.end-trip')}
              </Typography>
            </Button>
          </span>
        </span>
      ) : null}

      {destinationInformation() && !addStopInProgressStatus ? (
        <span className={classes.container}>
          <RoutesButton />
          <GoNow />
        </span>
      ) : null}

      {addStopInProgressStatus && !waypointScreen() && destinationInformation() ? (
        <span className={classes.container}>
          <Button className={classes.button__wrapper}>
            <Typography className={classes.button__text}>
              {t('poi-details.label.action-button.new-route')}
            </Typography>
          </Button>
          {Object.keys(stops).length === 0 ? (
            <Button onClick={onClickSaveStop} className={classes.button__blue}>
              <Typography className={classes.button__text__white}>
                {t('poi-details.label.action-button.add-stops')}
              </Typography>
            </Button>
          ) : (
            <Button onClick={onClickReplaceStop} className={classes.button__blue}>
              <Typography className={classes.button__text__white}>
                {t('poi-details.label.action-button.replace-stop')}
              </Typography>
            </Button>
          )}
        </span>
      ) : null}

      {(favoritesScreen() || recentsScreen()) && editListInprogress ? (
        <div className={classes.footer}>
          <Button className={classes.button__blue} onClick={onClickSaveFavRecent}>
            <Typography className={classes.button__text__white}>
              {t('edit-stop.label.action-button.save')}
            </Typography>
          </Button>
        </div>
      ) : null}

      {mpScreen() && incoming_stop.poi.marketEnabled === true ? (
        <React.Fragment>
          <Button
            onClick={onClickInitiateCall}
            className={classes.action__button}
            variant="outlined"
          >
            {t('mp-information.label.action-button.call')}
          </Button>
          <Button onClick={onClickShare} className={classes.share__button} variant="outlined">
            {t('mp-information.label.action-button.share')}
          </Button>
          <Button className={classes.action__button} variant="outlined">
            {t('mp-information.label.action-button.reserve')}
          </Button>
        </React.Fragment>
      ) : null}

      {routesScreen() && routeInProgress ? (
        <Button className={classes.button__blue} onClick={onClickContinueTrip}>
          <Typography className={classes.button__text__white}>
            {t('poi-details.label.action-button.continue-trip')}
          </Typography>
        </Button>
      ) : null}

      {routesScreen() && !routeInProgress ? <GoNow /> : null}

      {filterScreen() || sortByScreen() ? (
        <div className={classes.footer}>
          <Button className={classes.button__wrapper}>
            <Typography className={classes.button__text}>
              {t('filter.label.action-button.cancel')}
            </Typography>
          </Button>
          <Button className={classes.button__blue}>
            <Typography className={classes.button__text__white}>
              {t('filter.label.action-button.apply')}
            </Typography>
          </Button>
        </div>
      ) : null}
    </React.Fragment>
  );
};

Buttons.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  sendMessageToSocket: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  addStopInProgress: PropTypes.func.isRequired,
  addStopInProgressStatus: PropTypes.bool,
  stops: PropTypes.object,
  incoming_stop: PropTypes.object,
  markSinglePoi: PropTypes.func.isRequired,
  markPoiList: PropTypes.func.isRequired,
  saveStop: PropTypes.func.isRequired,
  editListInprogress: PropTypes.bool,
  editList: PropTypes.func.isRequired,
  routeInProgress: PropTypes.bool,
  dialogContinue: PropTypes.func.isRequired,
  // applyFilter: PropTypes.func.isRequired,
};

Buttons.defaultProps = {
  stops: {},
  incoming_stop: {},
  routeInProgress: false,
  addStopInProgressStatus: false,
  editListInprogress: false,
};

const mapStateToProps = ({ poi }) => ({
  addStopInProgressStatus: poi.stops_inprogress,
  number_of_stops: poi.number_of_stops,
  stops: poi.stops,
  incoming_stop: poi.incoming_stop,
  editListInprogress: poi.edit_list_inprogress,
  routeInProgress: poi.route_inprogress,
});

const mapDispatchToProps = dispatch => ({
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
  reset: () => dispatch({ type: POI_ACTION_TYPES.POI_RESET }),
  addStopInProgress: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.ADD_STOP_INPROGRESS, payload }),
  markSinglePoi: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.SINGLE_POI, payload }),
  markPoiList: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.POI_LIST_INPROGRESS, payload }),
  saveStop: payload => dispatch({ type: POI_ACTION_TYPES.STOPS, payload }),
  editList: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.EDIT_LIST_INPROGRESS, payload }),
  dialogContinue: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_DIALOG_CONTINUE, payload }),
  applyFilter: () => dispatch({ type: POI_ACTION_TYPES.FILTER.APPLY }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(Buttons)),
);
